import { useQuery } from '@tanstack/react-query';
import { fetchCallHistory, type CallLogRow } from '@/services/calls-api';

export function useCallHistory() {
  return useQuery<CallLogRow[]>({
    queryKey: ['calls', 'history'],
    queryFn: () => fetchCallHistory(50),
    staleTime: 30_000,
  });
}
